<template>
  <div
    class="file-wrapper"
    @mouseup="clickedAndMouseUp()"
  >
    <div
      class="aha-form-file"
      v-if="!isLoading"
    >
      <label
        for="drop-file"
      >
        <i class="text-secondary-50 mb-3 block">
          <aha-icon name="image-choice" :maintainColor="true" />
        </i>
        <p class="text-base-90 text-xs">
          Paste, drag and drop <br> or <b class="text-primary-100">click</b> to select image
        </p>

        <b-form-file
          v-model="file"
          :state="Boolean(file)"
          choose-label="Attachment2"
          :accept="config.accept"
          id="drop-file"
          :file-name-formatter="getFile"
          @mouseup.stop
        />
      </label>
    </div>
    <div v-if="isLoading" class="aha-uploading">
      Uploading...
      <aha-spinner variant="dark" class="mt-2" />
    </div>

    <div class="mb-4 mt-3 text-red-100 text-xs" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import Config from '@/config'
import Socket from '@/socket'
import PasteImageMixin from '@/mixins/presentation/PasteImageMixin'

const types = {
  image: {
    accept: '.png, .jpg, .gif, .svg',
  },
}

export default {
  mixins: [PasteImageMixin],
  props: {
    type: {
      type: String,
      default: 'image',
    },
    clickedAndMouseUp: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      file: null,
      config: {},
      isLoading: false,
      error: '',
    }
  },
  created() {
    this.config = types[this.type]
  },
  methods: {
    async getFile(files) {
      if (!files || !files.length) return
      const file = files[0]

      if (file && file.size > 15728640) {
        this.error = 'Could not upload this file (max size is 15 MB).'
        this.$emit('error', this.error)
        return
      }

      const errorString = 'Could not upload this file (only support image file jpg, svg, gif, png, ...).'
      if (file.type.indexOf('image') === -1) {
        this.error = errorString
        this.$emit('error', this.error)
        return
      }

      this.error = ''
      this.isLoading = true
      this.$emit('startUpload')
      const formData = new FormData()
      formData.append('file', file)
      formData.append('accessCode', this.$store.state.presentation.uniqueAccessCode)
      formData.append('socketId', Socket.getSocketId())
      formData.append('type', this.type)

      try {
        const res = await this.$http.post(Config.api.uploadImage, formData)
        this.$emit('callback', res.body.file.location)
        this.$emit('endUpload')
        this.isLoading = false
      } catch (error) {
        if (error.body.code === 'file_not_supported') {
          this.error = errorString
        } else {
          this.error = 'Cannot upload file. Please try again.'
        }
        this.isLoading = false
        this.$emit('error', this.error)
        this.$emit('endUpload')
        throw error
      }
    },

    // implement PasteImageMixin@uploadImgFromPaste
    uploadImgFromPaste(file) {
      this.getFile([file], 'paste')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
#drop-file__BV_file_outer_ {
  @apply opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer;
}

.file-wrapper {
  .aha-form-file {
    @apply flex flex-col items-center rounded justify-center text-center relative;
    @apply border border-dashed border-secondary-50 h-36 cursor-pointer;
  }

  .aha-uploading {
    @apply flex flex-col items-center rounded justify-center;
    @apply border border-secondary-50 h-36 text-center;
  }
}
</style>
